





















import {Component, Mixins, Watch} from "vue-property-decorator";
import SessionBlock from "@share/session/SessionBlock.vue";
import { ProgramDataHelper } from '@share/program/helpers/ProgramDataHelper';
import WithProfileMixin from "@mixins/WithProfileMixin";
import { MiniPlayerParams } from "@service/store/types/MiniPlayerState";
import { BackgroundViewName } from "./types/BackgroundViewName";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum"

@Component({
    components: { SessionBlock }
})
export default class SessionBackgroundWrapper extends Mixins(WithProfileMixin) {

    cachedSessionId = '';
    BackgroundViewName = BackgroundViewName;

    mounted() {
        this.cachedSessionId = this.sessionId || '';
    }

    updateSessionId(sessionId: string) {
        this.cachedSessionId = sessionId;
    }

    setVideoController(params: MiniPlayerParams) {
        if(params.object) {
            this.$emit('updateMiniPlayerParams', params);
        }
    }

    async closeSession() {

        this.$emit('liveConfirmed', false);

        this.$router.push({
            name: "Home",
            params: { ...this.$route.params, id: '' }
        });
    }

    get eventId(): string {
        return this.$store.state.events.selected;
    }

    get sessionId(): string | undefined {
        return [RouteNamesEnum.viewSession, RouteNamesEnum.webConferencesRecording].includes(this.$route.name as any) && this.$route.params?.id || this.cachedSessionId;
    }

    get isWebConferencesRecording() {
        return this.$route.name == RouteNamesEnum.webConferencesRecording;
    }

    @Watch('sessionId')
    watchSessionId(value: string) {
        this.cachedSessionId = value;
    }

    get programDataHelper(): ProgramDataHelper | undefined {
        return this.$store.getters['program/dataHelperByAgendaId'](this.sessionId) as ProgramDataHelper | undefined
    }

}
